import { render, staticRenderFns } from "./session-table.vue?vue&type=template&id=604bb9f2"
import script from "./session-table.vue?vue&type=script&lang=js"
export * from "./session-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports